// CONSTANTS are all caps.
const NS = 'SiteHeaderSearchBarV2';
const CLS = 'siteHeaderSearchBarV2';
const WG = '.' + CLS + '-';


export class SiteHeaderSearchBarV2 {
	constructor($el) {
		this.$el = $el;

		this.$siteHeader = document.querySelector('.siteHeaderV2');

		this.$searchClose = this.$el.querySelector(`${WG}closeBtn`);
		this.$searchInput = this.$el.querySelector(`${WG}searchInput`);
		this.$searchBtn = this.$el.querySelector(`${WG}searchBtn`);
		this.$results = $(this.$el.querySelector(`${WG}suggest-results`));
		this.$bigResults = $(this.$el.querySelector(`${WG}results`));
	}

	init() {
		this.initSearchBar();
		this.initJsonData();
	}

	initSearchBar() {
		this.$searchClose.addEventListener('click', () => {
			$(this.$siteHeader).trigger('siteHeaderV2.siteHeaderSearchBarV2.close');
		});

		this.$searchBtn.addEventListener('click', (e) => {
			this.runSearch(e);
		});

		this.$searchInput.addEventListener('keyup', (e) => {
			if (e.keyCode == 13) {
				this.runSearch(e);
			}
		});

		this.$searchInput.addEventListener('input', (e) => {
			this.inputEvent();
		});
	}

	initJsonData() {
		let json = this.$el.dataset.json;
		if (json) {
			let jsonObj = JSON.parse(json);
			this.searchUrl = jsonObj.searchUrl;
			this.autoCompleteUrl = jsonObj.autoCompleteUrl;
		}
	}

	runSearch(e) {
		if (!this.searchUrl) {
			return;
		}

		let keyword = this.$searchInput.value;
		window.location.href = `${this.searchUrl}?keyword=${keyword}`;
		e.stopPropagation();
		e.preventDefault();
	}

	inputEvent() {
		this.toggleResults(false);
		let searchKeyword = $(this.$searchInput).val();

		if (searchKeyword.trim().length < 3) {
			this.$bigResults.addClass('d-none');
			return;
		}

		let thisClass = this;
		this.getSuggestions = function() {
			$.ajax({
				url: this.autoCompleteUrl + '?prefix=' + searchKeyword + '&size=5',
				success: function(data) {
					if (data.status === 'ok' && data.hits != null && data.hits.length > 0) {
						thisClass.toggleResults(true);
						thisClass.renderResults(data.hits);
					}
				},
			});
		};

		this.getSuggestions();
	}

	toggleResults(isOpen) {
		isOpen
			? this.$bigResults.removeClass('d-none')
			: this.$bigResults.addClass('d-none');
	}

	renderResults(suggestions) {
		this.$results.empty();

		let htmlStr = '';
		for (let i = 0; i < suggestions.length; i++) {
			htmlStr += `<a class="${CLS}-suggestion text-decoration-none d-block" href="${this.searchUrl}?keyword=${suggestions[i].query}">
									<div class="d-flex align-items-center  text-white py-2">
										<span class="${CLS}-suggestion-name">${suggestions[i].query}</span>
									</div>
								</a>`;
		}
		this.$results.html(htmlStr);
	}
}
